// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"detail-actual-content_wrapper__X3nn4"};